




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AttendanceNavbar extends Vue {

  clickNavbarBurger() {
    const navbarburger = document.getElementById("navbar-burger");
    if (navbarburger){
      navbarburger.classList.toggle('is-active');    
    }
    const navbarmenu = document.getElementById("navbar-menu");
    if (navbarmenu){
      navbarmenu.classList.toggle('is-active');
    }
  }  
}
